import InvoiceCard from './invoiceCard';
import { format } from 'date-fns';
import Button from '../../../../components/button/button';

export default function OpenInvoices({ invoices = [], customers = [], onNavigate, hasMore, onLoadMore }) {
    const getCustomerFullName = (inv) => {
        if (!inv) return '';
        if (inv.customer && typeof inv.customer === 'object') {
            return `${inv.customer.prename || ''} ${inv.customer.name || ''}`.trim();
        }
        const cust = customers.find(c => c._id === inv.customer);
        return cust ? `${cust.prename || ''} ${cust.name || ''}`.trim() : '';
    };

    const displayedOpen = invoices.filter(inv => !inv.isPaid);

    return (
        <div className='invoiceSearchContainer'>
            <div className='invoiceCardContainer'>
                {displayedOpen.map((invoice, index) => {
                    const total = invoice.items.reduce((sum, item) => sum + (Number(item.totalBrut) || 0), 0);
                    const custName = getCustomerFullName(invoice) || 'Kein Name';
                    const [prename, ...rest] = custName.split(' ');
                    const name = rest.join(' ');

                    return (
                        <InvoiceCard
                            key={invoice._id || index}
                            custPrename={prename ?? 'Kein Vorname'}
                            custName={name ?? 'Kein Name'}
                            createdAt={invoice.createdAt ? format(new Date(invoice.createdAt), 'dd.MM.yyyy') : 'Kein Datum'}
                            total={total.toFixed(2) + ' €'}
                            paid={invoice.isPaid ? 'Ja' : 'Nein'}
                            onclick={() => onNavigate(invoice._id)}
                            invoiceNumber={invoice.invoiceNumber || 'Keine Rechnungsnummer'}
                        />
                    );
                })}
            </div>
            {hasMore && (
                <Button
                    className='containerButton'
                    onClick={onLoadMore}
                    buttonValue='Mehr laden'
                />
            )}
            {!hasMore && invoices.length > 0 && (
                <p>Alle Rechnungen geladen</p>
            )}
        </div>
    );
}
